import React from 'react';
export function HookSection() {
  return <section className="w-full bg-canvas px-4 py-12 sm:px-6 sm:py-20" data-id="element-73" data-mp="27fq7tm4my48m">
      <div className="mx-auto max-w-2xl text-center" data-id="element-74" data-mp="7hcaq622e2rx">
        <h2 className="font-display text-[1.6rem] font-extrabold leading-tight text-brand-deep sm:text-4xl" data-id="element-75" data-mp="m7a0gqfn70j8">
          ¿Te sientes una “falsa magra”?
        </h2>
        <p className="mt-4 text-[0.95rem] leading-relaxed text-gray-700 sm:mt-5 sm:text-lg" data-id="element-76" data-mp="h8ozupwhaeu9">
          Despiertas con el vientre relativamente plano, pero después de comer
          sientes inflamación, pesadez o como si tu abdomen cambiara por
          completo.
        </p>
        <p className="mt-4 text-[0.95rem] leading-relaxed text-gray-700 sm:mt-5 sm:text-lg" data-id="element-77" data-mp="2kbzlgqcy9ty">
          No siempre es cuestión de comer menos o hacer más cardio. Muchas veces
          el problema está en{' '}
          <strong className="font-semibold text-brand" data-id="element-78" data-mp="1dx4o8inuqi5s">
            la forma en que combinas tus comidas
          </strong>
          , tus horarios, tu descanso, tus niveles de estrés y ciertos hábitos
          que mantienen a tu cuerpo en modo inflamado.
        </p>
        <p className="mt-4 text-[0.95rem] leading-relaxed text-gray-700 sm:mt-5 sm:text-lg" data-id="element-79" data-mp="3lzjasz6clejf">
          Por eso Metabolismo Restart no se enfoca en dietas extremas, sino en
          enseñarte a comer y organizar tu rutina de una manera más inteligente,
          simple y sostenible.
        </p>

        <div className="mt-7 border-t border-brand/15 pt-7 sm:mt-8 sm:pt-8" data-id="element-80" data-mp="2yb03alv4h5se">
          <p className="font-display text-base font-extrabold leading-snug text-brand-deep sm:text-2xl" data-id="element-81" data-mp="32c1ucfevybja">
            Presentamos la Enciclopedia del Reinicio Metabólico: la metodología
            definitiva para recuperar tu figura, energía y ligereza desde la
            raíz.
          </p>
          <p className="mx-auto mt-3 max-w-xl text-[0.95rem] leading-relaxed text-gray-600 sm:mt-4 sm:text-lg" data-id="element-82" data-mp="3c3poio2tu6og">
            6 tomos digitales organizados en el orden exacto para ayudarte a
            entender qué está saboteando tu metabolismo y qué hacer paso a paso
            durante los próximos 9 días.
          </p>
        </div>
      </div>
    </section>;
}